import { Injectable } from '@angular/core';
import { UspComponent } from '../../components/usp/usp.component';
import { RouteIds, Step } from '../../types';
import { StepDefinitionStrategy } from './step-definition.strategy';
import { GoogleAnalyticsEventEnum } from '../../google-analytics';
import { Flows, Flow } from '@lx/quote-tool/lite/shared/types';

@Injectable({
  providedIn: 'root',
})
export class CourseStepDefinitionService implements StepDefinitionStrategy {
  getStepDefinition(activeFlow: Flow) {
    return this.createStepDefinition(activeFlow);
  }

  private createStepDefinition(activeFlow: Flow): Step {
    return {
      id: RouteIds.course,
      title: $localize`Your price quote`,
      subtitles: [$localize`No matter what your language level is, we have the perfect course for you! Tell us your interests and we'll give you a quote!`],
      floatingPanel: {
        component: UspComponent,
        position: 'content',
      },
      nextButton: $localize`Next`,
      valid: false,
      googleAnalyticsEvent: GoogleAnalyticsEventEnum.Course,
      shareableDeeplink: true,
      nextStep: () => (activeFlow === Flows.Online ? RouteIds.applicant : RouteIds.extras),
    };
  }
}
